import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=3265eaf0&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=ts"
export * from "./Budget.vue?vue&type=script&lang=ts"
import style0 from "./Budget.vue?vue&type=style&index=0&id=3265eaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3265eaf0",
  null
  
)

export default component.exports